import React, { SVGProps } from 'react';

export const ThumbsDownOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m12.105 20.666 1.902.634 3.697-8.009h2.424a2.1 2.1 0 0 0 2.1-2.1v-7.2a2.1 2.1 0 0 0-2.1-2.1H6.608A2.1 2.1 0 0 0 4.604 3.36l-2.35 7.439a3.3 3.3 0 0 0 3.147 4.293h3.626v1.306a4.5 4.5 0 0 0 3.077 4.269Zm4.423-9.122-3.48 7.539-.374-.125a2.7 2.7 0 0 1-1.846-2.561V13.29H5.402a1.5 1.5 0 0 1-1.43-1.951L6.322 3.9a.3.3 0 0 1 .285-.21h9.92v7.853Zm1.8-.053v-7.8h1.8a.3.3 0 0 1 .3.3v7.2a.3.3 0 0 1-.3.3h-1.8Z"
    />
  </svg>
);
